import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import Card from "components/cards/Card";
import {
  Grid,
  TextField,
  InputAdornment,
  CardContent,
  CardMedia,
  Typography,
  Button,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import causesTestData from "testdata/causesData";
import { useHistory } from "react-router-dom";
import NoData from "components/NoData";

export default function CausesPage() {
  const classes = useStyles();
  const history = useHistory();

  const [causesData, setCausesData] = useState(causesTestData);
  const [searchData, setSearchData] = useState(causesTestData);

  const handleSearch = (value) => {
    searchCausesData(value);
  };

  useEffect(() => {}, []);

  const searchCausesData = (value) => {
    let causesData_ = [];

    for (let i = 0; i < searchData.length; i++) {
      if (
        searchData[i].title.toLowerCase().includes(value.toLowerCase()) ||
        searchData[i].description.toLowerCase().includes(value.toLowerCase()) ||
        searchData[i].long_description
          .toLowerCase()
          .includes(value.toLowerCase())
      ) {
        causesData_ = [...causesData_, searchData[i]];
      }
    }

    setCausesData(causesData_);
  };

  return (
    <div className={classes.container}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <TextField
            className={classes.inputField}
            placeholder="Search Causes"
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={8}
          md={8}
          lg={8}
          xl={8}
          className={classes.noGrid}
        ></Grid>
        {causesData.length > 0 ? (
          causesData.map((causeData) => (
            <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
              <Card className={classes.causesCardView}>
                <CardMedia
                  image={causeData.image}
                  className={classes.causesImage}
                >
                  <img
                    src={causeData.symbol}
                    className={classes.causesSymbol}
                  />
                </CardMedia>
                <CardContent className={classes.causesContent}>
                  <Typography className={classes.causesTitle} component={"h2"}>
                    {causeData.title}
                  </Typography>
                  <Typography
                    className={classes.causesDescription}
                    component={"h2"}
                  >
                    {causeData.description}
                  </Typography>
                  <Button
                    className={classes.websiteButton}
                    variant="contained"
                    onClick={() => {
                      history.push("/causes-details/" + causeData.id);
                    }}
                  >
                    LEARN MORE
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <NoData />
            </Grid>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  noGrid: {
    display: "block",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  container: {
    position: "relative",
    minHeight: 400,
  },
  inputField: {
    width: "100%",
    height: 36,
    background: "#F9F9F9",
    "& .MuiOutlinedInput-root": {
      height: 36,
    },
  },
  causesCardView: {
    height: "436px",
    position: "relative",

    "& span": {
      fontFamily: "Proxima Nova, sans-serif !important",
    },
    "& .MuiCardContent-root": {
      padding: 0,
    },
  },
  causesImage: {
    width: "100%",
    height: "200px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  causesSymbol: {
    position: "relative",
    top: "9%",
    left: "5%",
  },
  causesGrid: {
    paddingTop: "40px !important",
    paddingRight: "40px !important",
    paddingBottom: "40px !important",
  },
  causesTitle: {
    height: "50px",
    margin: "15px 0px",
    fontSize: 20,
    fontWeight: "bold",
    lineHeight: "24px",
    maxWidth: "100%",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  causesDescription: {
    fontSize: 14,
    lineHeight: "20px",
    color: "#6C757D",
    maxWidth: "100%",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 4,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  websiteButton: {
    // position: "absolute",
    bottom: 0,
    marginBottom: 15,
    marginTop: 15,
    // width: "87%",
    width: "100%",
    fontSize: 12,
    fontWeight: 600,
    backgroundColor: `${theme.palette.primary.primaryButton} !important`,
    color: `${theme.palette.primary.primaryButtonLabel} !important`,
  },
  causesContent: {
    padding: "10px 24px 24px 24px !important",
  },
}));
